import React from 'react';
import loadable from '../../utils/loadable';
import './index.less';
const WorkWithUs = loadable(() => import('../../components/workWithUs'))
const BackgroundOverlay = loadable(() => import('../../components/backgroundOverlay'))
class ContactPage extends React.Component {

    render() {
        return (
            <>
                <BackgroundOverlay />
                <WorkWithUs />
            </>
        );
    }
}

export default ContactPage;
